import { useMutation, useQueryClient } from "react-query";
import { useProfile } from "../queries/useProfile";
import { Profile, User } from "../../models/api.model";
import { useIdToken } from "../queries/useIdToken";

const addUserToOrg = async (
  token: string,
  profile: Profile | undefined,
  organizationId: string
): Promise<User> => {
  if (!profile) {
    throw Error("No found profile.");
  }

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/users/${profile.id}/organizations`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ organizationId }),
    }
  );

  const json = await response.json();
  return json.user;
};

export const useAddUserToOrg = () => {
  const { data: token } = useIdToken();
  const { data: profile } = useProfile();
  const queryClient = useQueryClient();

  return useMutation(
    (organizationId: any) =>
      addUserToOrg(token as string, profile, organizationId),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries("profile");
      },
    }
  );
};
